import { FaExternalLinkAlt, FaEye } from "react-icons/fa";
import Tooltip from "../ToolTip";

/**
 * Botón tipo DetailsButton pero más grande (padding + ícono).
 * Props:
 * - action?: () => void
 * - content: string (tooltip)
 * - type?: "eye" | "externalLink"
 */
const DetailsButtonLarge = ({ action, content, type = "eye" }) => {
  return (
    <Tooltip content={content}>
      <button
        type="button"
        onClick={() => (action ? action() : null)}
        className="p-2.5 text-blue-600 hover:bg-blue-600 hover:bg-opacity-25 hover:cursor-pointer rounded-md bg-blue-700 bg-opacity-10 flex transition-all duration-100 items-center"
      >
        {type === "eye" ? (
          <FaEye className="text-[14px]" />
        ) : type === "externalLink" ? (
          <FaExternalLinkAlt className="text-[14px]" />
        ) : null}
      </button>
    </Tooltip>
  );
};

export default DetailsButtonLarge;

